import api from "./api";
import {default as nuvei} from "./nuveiApi";
import { getTabclixCode } from "../helpers/embed-code";

let code = getTabclixCode()

const URLS = {
    postFormsURL: '/api/nuvei/makePay',
}


export async function postNuveiPayment(authToken, formData) {


    return api.post(URLS.postFormsURL, formData, {
        headers: {
            'userID': code,
            'Authorization': `Bearer ${authToken}`,
        }
    })
}
